import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig } from '../data/siteConfig';
import { buttonClasses } from '../utils/buttonStyles';

/** Mirrors the purpose-matched thank-you page the native feedback frame redirects to. */
export function ContactThankYou() {
  const location = useLocation();
  const name = (location.state as {
    name?: string;
  } | null)?.name;
  const {
    support
  } = siteConfig;
  return <div className="mx-auto max-w-page px-5 py-20 md:px-10 md:py-28" data-id="element-532" data-mp="2xj8atotg1a43">
      <div className="max-w-2xl" data-id="element-533" data-mp="32fys2fgzibr3">
        <span aria-hidden="true" className="block h-px w-12 bg-bronze" data-id="element-534" data-mp="32h0eth7d4mon" />
        <h1 className="mt-8 font-display text-[46px] font-medium leading-[1.03] text-ink md:text-[64px]" data-id="element-535" data-mp="37ethw1ddd0kp">
          Thank you{name ? `, ${name}` : ''}.
        </h1>
        <p className="mt-5 max-w-lg text-[17px] leading-relaxed text-ink-muted" data-id="element-536" data-mp="mpw1r81k7smi">
          Your message is with our support team. If you’d like to talk sooner, call{' '}
          <a href={support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-537" data-mp="rqtj5ieqwimy">
            {support.phone}
          </a>{' '}
          during support hours.
        </p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-538" data-mp="3a9pg3p5wqvra">
          <Link to="/" className={buttonClasses('primary')} data-id="element-539" data-mp="3669mz2t1rdjc">
            Back to home
          </Link>
          <Link to="/#faqs" className={buttonClasses('secondary')} data-id="element-540" data-mp="3176ipkkw5bcf">
            Read the FAQs
          </Link>
        </div>
      </div>
    </div>;
}